import React from "react";
import {
  MDBContainer,
  MDBFooter,
  MDBRow,
  MDBCol,
  MDBView,
  MDBNavLink,
} from "mdbreact";
import Imagen_logo from "../../images/Logotipo_footer.png";
import "../pages/Landing/Inicio.css";
import Imagen_play_store from "../../images/CTA-google.png";
import Imagen_app_store from "../../images/CTA-Apple.png";
import * as ROUTES from "../../constants/routes";

const FooterPage = () => {
  return (
    <div id="apppage">
      <MDBView className="view-footer">
        <MDBFooter className="font-small pt-4 mt-4">
          <MDBContainer fluid>
            <MDBRow
              style={{
                alignItems: "start",
              }}
            >
              <MDBCol lg="3" md="3" sm="12">
                <MDBRow start>
                  <img src={Imagen_logo} alt="" />
                  <p className="f_subtitle" style={{ marginLeft: "1rem" }}>
                    Korea e Iñaquito
                  </p>
                </MDBRow>
              </MDBCol>
              <MDBCol lg="4" md="2" sm="12" around>
                <MDBRow start>
                  <div>
                    <p className="f_title">Navegación</p>
                    <MDBNavLink
                      className="f_subtitle"
                      to={ROUTES.HOME}
                      style={{ color: "#ffffff" }}
                    >
                      Inicio
                    </MDBNavLink>
                    <MDBNavLink
                      className="f_subtitle"
                      to={ROUTES.PASSENGERS}
                      style={{ color: "#ffffff" }}
                    >
                      Conductor
                    </MDBNavLink>
                    <MDBNavLink
                      className="f_subtitle"
                      to={ROUTES.DRIVERS}
                      style={{ color: "#ffffff" }}
                    >
                      Pasajeros
                    </MDBNavLink>
                    <MDBNavLink
                      className="f_subtitle"
                      to={ROUTES.QUESTIONS}
                      style={{ color: "#ffffff" }}
                    >
                      Preguntas Frecuentes
                    </MDBNavLink>
                    <MDBNavLink
                      className="f_subtitle"
                      to={ROUTES.TERMS}
                      style={{ color: "#ffffff" }}
                    >
                      Términos y condiciones
                    </MDBNavLink>
                  </div>
                </MDBRow>
              </MDBCol>
              {/* <MDBCol lg="3" md="3" sm="12">
                <MDBRow start>
                  <div>
                    <p className="f_title">.</p>
                    <p className="f_subtitle">Preguntas Frecuentes </p>
                    <p className="f_subtitle">Términos y Condiciones</p>{" "}
                    <p className="f_subtitle">info@tovo.com.ec</p>
                  </div>
                </MDBRow>
              </MDBCol> */}
              <MDBCol lg="4" md="4" sm="12">
                <MDBRow start>
                  <p className="f_title" style={{ fontSize: "20px" }}>
                    Envíanos un mensaje {""}
                  </p>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="email"
                  />
                  <p
                    className="h1_ronny"
                    style={{
                      fontSize: "20px",
                      margin: "1rem",
                      textAlign: "center",
                    }}
                  >
                    Descarga la app {""}
                  </p>
                  <MDBRow>
                    <MDBCol lg="6" md="6" sm="12">
                      <MDBRow around className="ml-2">
                        <div
                          style={{ marginTop: "10px", marginBottom: "20px" }}
                        >
                          <a href="https://play.google.com/store/apps/details?id=com.tovo.tovo_app">
                            <img
                              id="imagen_google"
                              src={Imagen_play_store}
                              width="100%"
                              alt="30"
                            />
                          </a>
                        </div>
                      </MDBRow>
                    </MDBCol>
                    <MDBCol lg="6" md="6" sm="12">
                      <MDBRow around className="ml-2">
                        <div
                          style={{ marginTop: "10px", marginBottom: "20px" }}
                        >
                          <a href="https://apps.apple.com/us/app/tovo/id1562931806">
                            <img
                              id="imagen_apple"
                              src={Imagen_app_store}
                              width="100%"
                              alt="30"
                            />
                          </a>
                        </div>
                      </MDBRow>
                    </MDBCol>
                  </MDBRow>
                </MDBRow>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
          <div
            className="derechos footer-copyright text-left py-2 "
            style={{
              marginTop: "220px",
            }}
          >
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Tovo. Todos los derechos
              reservados
            </MDBContainer>
          </div>
        </MDBFooter>
      </MDBView>
    </div>
  );
};

export default FooterPage;
